<template>
  <template v-if="isMobile">
    <TransitionRoot appear :show="showMenu" as="template">
      <Dialog as="div" @close="closeMenu">
        <div class="fixed inset-0 z-30 overflow-y-auto">
          <div class="min-h-screen text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-10"
              leave="duration-200 ease-in"
              leave-from="opacity-10"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
            </TransitionChild>

            <TransitionChild
              as="template"
              enter="transition ease-in-out duration-700 transform"
              enter-from="translate-y-full scale-0"
              enter-to="translate-y-0 scale-100"
              leave="transition ease-in-out duration-700 transform"
              leave-from="translate-y-0"
              leave-to="translate-y-full"
            >
              <div
                class="inset-x-0 bottom-0 absolute w-full overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg py-5 px-5"
              >
                <div class="flex flex-col justify-between h-full">
                  <div class="flex flex-col">
                    <div class="flex flex-row justify-between">
                      <div class="flex items-center">
                        <h2 class="text-lg">Filters</h2>
                      </div>
                      <div
                        @click="closeMenu"
                        class="flex justify-end items-center cursor-pointer"
                      >
                        <XIcon class="text-brand-dark-gray w-5 h-5" />
                      </div>
                    </div>

                    <Line />

                    <div class="flex flex-col py-1">
                      <div class="flex flex-row justify-between mb-3">
                        <h5 class="font-semibold">Reports ready</h5>
                        <div class="flex items-center">
                          <ChevronUpIcon class="text-brand-green w-5 h-5" />
                        </div>
                      </div>

                      <div class="flex items-center py-1">
                        <input
                          id="credit"
                          type="checkbox"
                          class="rounded border-gray-300 text-brand-green focus:ring-brand-green text-sm"
                          v-model="credit"
                        />
                        <label
                          for="credit"
                          class="ml-2 block text-brand-black text-sm"
                          >Credit</label
                        >
                      </div>

                      <div class="flex items-center py-1">
                        <input
                          id="employment"
                          type="checkbox"
                          class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                          v-model="employment"
                        />
                        <label
                          for="employment"
                          class="ml-2 block text-brand-black text-sm"
                          >Employment Verification</label
                        >
                      </div>
                      <div class="flex items-center py-1">
                        <input
                          id="landlord"
                          type="checkbox"
                          class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                          v-model="landlord"
                        />
                        <label
                          for="landlord"
                          class="ml-2 block text-brand-black text-sm"
                          >Landlord Verification</label
                        >
                      </div>
                      <div class="flex items-center py-1">
                        <input
                          id="criminal"
                          type="checkbox"
                          class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                          v-model="criminal"
                        />
                        <label
                          for="criminal"
                          class="ml-2 block text-brand-black text-sm"
                          >Criminal</label
                        >
                      </div>
                      <div class="flex items-center py-1">
                        <input
                          id="eviction"
                          type="checkbox"
                          class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                          v-model="eviction"
                        />
                        <label
                          for="eviction"
                          class="ml-2 block text-brand-black text-sm"
                          >Eviction</label
                        >
                      </div>

                      <Line />

                      <div class="flex flex-row justify-between my-3">
                        <h5 class="font-semibold">Properties</h5>
                        <div class="flex items-center">
                          <ChevronUpIcon class="text-brand-green w-5 h-5" />
                        </div>
                      </div>

                      <div class="relative">
                        <SearchIcon
                          class="w-5 h-5 text-brand-green absolute top-2.5 left-4"
                        />
                        <input
                          type="text"
                          ref="search"
                          class="w-full py-2 pl-12 pr-2 placeholder-brand-mid-gray outline-none ring-0 inline-block caret-brand-green text-sm border border-brand-mid-gray rounded focus:ring-0 focus:outline-none focus:border-brand-green"
                          placeholder="Search properties"
                          v-model="searchTerm"
                        />
                        <div
                          class="py-1 px-1 absolute top-2 right-3 rounded bg-brand-mid-gray cursor-pointer"
                          @click="clearSearch"
                          v-if="searchTerm"
                        >
                          <p class="text-xs text-brand-dark-gray">clear</p>
                        </div>
                      </div>

                      <div class="flex flex-col my-5">
                        <h5 class="font-semibold">Recently applied to</h5>
                        <div class="flex flex-col py-1">
                          <div
                            class="flex flex-row justify-between py-1"
                            v-for="(
                              recent, index
                            ) in recentApplicationUnitAddresses"
                            :key="index"
                          >
                            <div
                              class="flex flex-row cursor-pointer"
                              @click="handleSearch(recent)"
                            >
                              <div class="flex items-center mr-3">
                                <ClockIcon
                                  class="w-5 h-5 text-brand-dark-gray"
                                />
                              </div>
                              <div class="flex items-center">
                                <p
                                  class="text-brand-dark-gray truncate overflow-ellipsis"
                                >
                                  {{ recent }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center shadow-lg">
                    <PrimaryButton @click="closeMenu"
                      >Apply filters</PrimaryButton
                    >
                  </div>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </template>

  <template v-else>
    <div
      class="sidebar bg-white shadow-md py-5 px-5 fixed inset-y-0 top-0 left-0 transform transition duration-200 ease-in-out z-10 h-screen w-72 overflow-y-scroll"
      :class="[showMenu ? 'translate-x-20' : '-translate-x-full']"
      ref="menu"
    >
      <div class="flex flex-col justify-between h-full">
        <div class="flex flex-col">
          <div class="flex flex-row justify-between">
            <div class="flex items-center">
              <h2>Filters</h2>
            </div>
            <div
              @click="closeMenu"
              class="flex justify-end items-center cursor-pointer"
            >
              <XIcon class="text-brand-dark-gray w-7 h-7" />
            </div>
          </div>

          <Line />

          <div class="flex flex-col py-3">
            <div class="flex flex-row justify-between mb-3">
              <h5 class="font-semibold">Reports ready</h5>
              <div class="flex items-center">
                <ChevronUpIcon class="text-brand-green w-6 h-6" />
              </div>
            </div>

            <div class="flex items-center py-1">
              <input
                id="credit"
                type="checkbox"
                class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                v-model="credit"
              />
              <label for="credit" class="ml-2 block text-brand-black"
                >Credit</label
              >
            </div>

            <div class="flex items-center py-1">
              <input
                id="employment"
                type="checkbox"
                class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                v-model="employment"
              />
              <label for="employment" class="ml-2 block text-brand-black"
                >Employment Verification</label
              >
            </div>
            <div class="flex items-center py-1">
              <input
                id="landlord"
                type="checkbox"
                class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                v-model="landlord"
              />
              <label for="landlord" class="ml-2 block text-brand-black"
                >Landlord Verification</label
              >
            </div>
            <div class="flex items-center py-1">
              <input
                id="criminal"
                type="checkbox"
                class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                v-model="criminal"
              />
              <label for="criminal" class="ml-2 block text-brand-black"
                >Criminal</label
              >
            </div>
            <div class="flex items-center py-1">
              <input
                id="eviction"
                type="checkbox"
                class="rounded border-gray-300 text-brand-green focus:ring-brand-green"
                v-model="eviction"
              />
              <label for="eviction" class="ml-2 block text-brand-black"
                >Eviction</label
              >
            </div>

            <Line />

            <div class="flex flex-row justify-between my-3">
              <h5 class="font-semibold">Properties</h5>
              <div class="flex items-center">
                <ChevronUpIcon class="text-brand-green w-6 h-6" />
              </div>
            </div>

            <div class="relative">
              <SearchIcon
                class="w-5 h-5 text-brand-green absolute top-2.5 left-4"
              />
              <input
                type="text"
                ref="search"
                class="w-full py-2 pl-12 pr-2 placeholder-brand-mid-gray outline-none ring-0 inline-block caret-brand-green text-sm border border-brand-mid-gray rounded focus:ring-0 focus:outline-none focus:border-brand-green"
                placeholder="Search properties"
                v-model="searchTerm"
                @keyup.enter="handleSearch"
              />
              <div
                class="py-1 px-1 absolute top-2 right-3 rounded bg-brand-mid-gray cursor-pointer"
                @click="clearSearch"
                v-if="searchTerm"
              >
                <p class="text-xs text-brand-dark-gray">clear</p>
              </div>
            </div>

            <div class="flex flex-col my-5">
              <h5 class="font-semibold">Recently applied to</h5>
              <div class="flex flex-col py-1">
                <div
                  class="flex flex-row justify-between py-1"
                  v-for="recent in recentApplicationUnitAddresses"
                  :key="recent"
                >
                  <div
                    class="flex flex-row cursor-pointer"
                    @click="handleSearch(recent)"
                  >
                    <div class="flex items-center mr-3">
                      <ClockIcon class="w-5 h-5 text-brand-dark-gray" />
                    </div>
                    <div class="flex items-center">
                      <p
                        class="text-brand-dark-gray truncate overflow-ellipsis"
                      >
                        {{ recent }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center shadow-lg">
          <PrimaryButton @click="closeMenu">Apply filters</PrimaryButton>
        </div>
      </div>
    </div>
  </template>
</template>
<script>
import {
  XIcon,
  ChevronUpIcon,
  SearchIcon,
  ClockIcon
} from "@heroicons/vue/outline"

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
} from "@headlessui/vue"

import { mapGetters } from "vuex"

export default {
  components: {
    XIcon,
    ChevronUpIcon,
    SearchIcon,
    ClockIcon,
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay
  },
  props: {
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close"],
  computed: {
    ...mapGetters(["getApplicationBundles"]),
    recentApplicationUnitAddresses() {
      if (!this.getApplicationBundles) return []

      return this.getApplicationBundles
        .map((bundle) => {
          return bundle.applications.map((app) => {
            return app.unit_address
          })
        })
        .flat()
        .slice(0, 5)
    }
  },
  data() {
    return {
      credit: false,
      employment: false,
      landlord: false,
      criminal: false,
      eviction: false,
      searchTerm: ""
    }
  },
  methods: {
    closeMenu() {
      const reportKeys = [
        "credit",
        "employment",
        "landlord",
        "criminal",
        "eviction"
      ]

      const reports =
        reportKeys
          .map((key) => {
            return this[key] ? key : ""
          })
          .filter(Boolean) || []

      const filters = {
        reports
      }

      this.$emit("close", {
        filters,
        searchTerm: this.searchTerm
      })
    },
    handleSearch(search) {
      if (search) {
        this.searchTerm = search
      }

      this.closeMenu()
    },
    clearSearch() {
      this.searchTerm = ""
    }
  }
}
</script>
